<div class="cockpit-content">
  <h1>{{ 'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.title' | translate }}</h1>

  <app-chart-download-button (buttonClick)="exportTable1()">
    @if (isForM2) {
      <h2 class="title" translate>sprint9.cockpit.card.all.tabelle</h2>
    }
    @if (!isForM2) {
      <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.fn.subtitle</h2>
    }
  </app-chart-download-button>

  <div class="table-wrapper">
    <table id="funkstat-loehne.fn" class="striped">
      <thead>
        <tr>
          <td rowspan="2" class="no-border"><br></td>
          @if (!isForM2) {
            <th rowspan="2" scope="colgroup" style="width: 140px" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bst.umbruch' |translate"></th>
          }
          @if (!isForM2) {
            <th rowspan="2" scope="colgroup" style="width: 180px;" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bkn.umbruch' |translate"></th>
          }
          @if (isForM2) {
            <th rowspan="2" scope="colgroup" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m2.sprint5.cockpit.card.funktionenstatistiken.funktionswert.umbruch' |translate"></th>
          }
          <th rowspan="2" colspan="6" scope="colgroup" class="header bold centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.gesamtverdienst</th>
          <th rowspan="2"  scope="colgroup" class="header bold centered" [innerHTML]="'m2.sprint4.cockpit.card.funktionenstatistiken.diff-percVomMaennerlohn' | translate"></th>
          <th rowspan="1" colspan="8" scope="colgroup" class="header bold centered border-bold-left border-bold-right" translate>
          m2.sprint9.cockpit.card.funktionenstatistiken.loehne.LohnbestandteileDurchschnittswerte</th>
        </tr>
        <tr>
          <th scope="colgroup" colspan="2" class="header centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.grundlohn</th>
          <th scope="colgroup" colspan="2" class="header centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.13Monatslohn</th>
          <th scope="colgroup" colspan="2" class="header centered border-bold-left border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.zulagen</th>
          <th scope="colgroup" colspan="2" class="header centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.sonderzahlungen</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="col" colspan="1" class="header bold centered border-bold-left border-bold-right" translate>m2.sprint4.cockpit.card.funktionenstatistiken.funktion</th>
          @if (!isForM2) {
            <td class="centered border-bold-right"></td>
          }
          <td class="centered border-bold-right"></td>
          <td class="centered" translate>i18n.common.min</td>
          <td class="centered" translate>i18n.common.max</td>
          <td class="centered border-bold-right" translate>i18n.common.range</td>

          <td class="centered" innerHtml="{{'m2.sprint4.common.alle' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
          <td class="centered" innerHtml="{{'i18n.common.maenner' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
          <td class="centered" innerHtml="{{'i18n.common.frauen' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
          <td class="centered border-bold-right"></td>
          <td class="centered" translate>i18n.common.maenner</td>
          <td class="centered border-bold-right" translate>i18n.common.frauen</td>
          <td class="centered" translate>i18n.common.maenner</td>
          <td class="centered border-bold-right" translate>i18n.common.frauen</td>
          <td class="centered" translate>i18n.common.maenner</td>
          <td class="centered border-bold-right" translate>i18n.common.frauen</td>
          <td class="centered" translate>i18n.common.maenner</td>
          <td class="centered border-bold-right" translate>i18n.common.frauen</td>
        </tr>

        @for (item of nachFunktion; track item) {
          <tr class="content">
            <th scope="col" colspan="1" class="border-bold-left border-bold-right">{{item?.funktionId | retrieveCaption: funktionen}}</th>
            @if (!isForM2) {
              <td class="text-align-right border-bold-right">{{item?.BST | numberFormat: crtLocale }}</td>
            }
            @if (!isForM2) {
              <td class="text-align-right border-bold-right">{{item?.BKN | numberFormat: crtLocale }}</td>
            }
            @if (isForM2) {
              <td class="text-align-right border-bold-right">{{item?.funktionsWert | numberFormat: crtLocale }}</td>
            }
            <td class="text-align-right">{{item?.minLohn | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.maxLohn | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.spannweiteLohn | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.durchschnittslohn | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.durchschnittslohnMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.durchschnittslohnFrauen | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.durchschnittslohnDifferenz | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.grundlohnMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.grundlohnFrauen | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.monatslohn13Maenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.monatslohn13Frauen | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.zulagenMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right" translate>{{item?.zulagenFrauen | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.sonderzahlungenMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.sonderzahlungenFrauen | numberFormat: crtLocale }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <!-- total row -->
        <tr class="content">
          <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top"translate >i18n.common.total</th>
          <td class="text-align-right border-bold-right border-bold-top"></td>
          @if (!isForM2) {
            <td class="text-align-right border-bold-right border-bold-top"></td>
          }
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.minLohn | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.maxLohn | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.spannweiteLohn | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohn | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnFrauen | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnDifferenz | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.grundlohnMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.grundlohnFrauen | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.monatslohn13Maenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.monatslohn13Frauen | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.zulagenMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top" translate>{{gesamtesUnternehmen?.zulagenFrauen | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.sonderzahlungenMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.sonderzahlungenFrauen | numberFormat: crtLocale }}</td>
        </tr>
        <tr>
          @if (!isForM2) {
            <td colspan="17" class="hint pt-1" translate>
            m1.sprint10.cockpit.card.funktionenstatistiken.loehne.footer-hint</td>
          }
          @if (isForM2) {
            <td colspan="16" class="hint pt-1" translate>
              m2.sprint10.cockpit.card.funktionenstatistiken.loehne.footer-hint
            </td>
          }
        </tr>
        <tfoot>
        </table>
      </div>

      <div style="padding-bottom: 15px;padding-top: 15px;">
      </div>

      @if (!isForM2) {
        <div>
          <app-chart-download-button (buttonClick)="exportTable2()">
            <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.bst-anf.subtitle</h2>
          </app-chart-download-button>
          <div class="table-wrapper">
            <table id="funkstat-loehne.bst-anf" class="striped">
              <thead >
                <tr>
                  <th rowspan="2" scope="colgroup" style="width: 140px" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bst.umbruch' |translate"></th>
                  <th rowspan="2" scope="colgroup" style="width: 180px;" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bkn.umbruch' |translate"></th>
                  <th rowspan="2" colspan="6" scope="colgroup" class="header bold centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.gesamtverdienst</th>
                  <th rowspan="2"  scope="colgroup" class="header bold centered" [innerHTML]="'m2.sprint4.cockpit.card.funktionenstatistiken.diff-percVomMaennerlohn' | translate"></th>
                  <th rowspan="1" colspan="8" scope="colgroup" class="header bold centered border-bold-left border-bold-right" translate>
                  m2.sprint9.cockpit.card.funktionenstatistiken.loehne.LohnbestandteileDurchschnittswerte</th>
                </tr>
                <tr >
                  <th scope="colgroup" colspan="2" class="header centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.grundlohn</th>
                  <th scope="colgroup" colspan="2" class="header centered border-bold-left" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.13Monatslohn</th>
                  <th scope="colgroup" colspan="2" class="header centered border-bold-left border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.zulagen</th>
                  <th scope="colgroup" colspan="2" class="header centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.loehne.sonderzahlungen</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="centered border-bold-left border-bold-right"></td>
                  <td class="centered border-bold-right"></td>
                  <td class="centered" translate>i18n.common.min</td>
                  <td class="centered" translate>i18n.common.max</td>
                  <td class="centered border-bold-right" translate>i18n.common.range</td>
                  <td class="centered" innerHtml="{{'m2.sprint4.common.alle' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
                  <td class="centered" innerHtml="{{'i18n.common.maenner' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
                  <td class="centered" innerHtml="{{'i18n.common.frauen' | translate}} ({{'m2.sprint9.cockpit.card.funktionenstatistiken.loehne.durchschnitt' | translate}})"></td>
                  <td class="centered border-bold-right"></td>
                  <td class="centered" translate>i18n.common.maenner</td>
                  <td class="centered border-bold-right" translate>i18n.common.frauen</td>
                  <td class="centered" translate>i18n.common.maenner</td>
                  <td class="centered border-bold-right" translate>i18n.common.frauen</td>
                  <td class="centered" translate>i18n.common.maenner</td>
                  <td class="centered border-bold-right" translate>i18n.common.frauen</td>
                  <td class="centered" translate>i18n.common.maenner</td>
                  <td class="centered border-bold-right" translate>i18n.common.frauen</td>
                </tr>
                @for (item of nachCodierung; track item) {
                  <tr class="content">
                    <td class="text-align-right border-bold-left border-bold-right">{{item?.BST | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.BKN | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.minLohn | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.maxLohn | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.spannweiteLohn | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.durchschnittslohn | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.durchschnittslohnMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.durchschnittslohnFrauen | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.durchschnittslohnDifferenz | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.grundlohnMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.grundlohnFrauen | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.monatslohn13Maenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.monatslohn13Frauen | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.zulagenMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right" translate>{{item?.zulagenFrauen | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.sonderzahlungenMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.sonderzahlungenFrauen | numberFormat: crtLocale }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <!-- total row -->
                <tr class="content">
                  <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top" translate >i18n.common.total</th>
                  <td class="text-align-right border-bold-right border-bold-top"></td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.minLohn | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.maxLohn | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.spannweiteLohn | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohn | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.durchschnittslohnDifferenz | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.grundlohnMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.grundlohnFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.monatslohn13Maenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.monatslohn13Frauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.zulagenMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top" translate>{{gesamtesUnternehmen?.zulagenFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.sonderzahlungenMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.sonderzahlungenFrauen | numberFormat: crtLocale }}</td>
                </tr>
                <tr>
                  <td colspan="17" class="hint pt-1" translate>
                  m1.sprint10.cockpit.card.funktionenstatistiken.loehne.bst-anf.footer-hint</td>
                </tr>
                <tfoot>
                </table>
              </div>
            </div>
          }
        </div>

        <div style="padding-bottom: 15px;padding-top: 15px;">
        </div>
